import { z } from 'zod';
const versionedIdentifier = z.string().min(5).max(160)
    .regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+\.v[1-9][0-9]*$/);
export const timesheetsAssistantContextCapability = 'timesheets.assistant-context.v1';
export const timesheetsAssistantContextProviderId = timesheetsAssistantContextCapability;
export const timesheetsAssistantContextSlot = 'platform.server.optional-context';
export const timesheetsAssistantContextRequestSchema = z.strictObject({
    requestId: z.string().uuid(),
    subjectType: z.enum(['timesheets.time-entry', 'timesheets.membership-history']),
    subjectId: z.string().uuid().nullable(),
    query: z.string().trim().max(160).nullable().optional(),
    requestedCapabilities: z.array(versionedIdentifier).min(1).max(50),
    redactionProfile: z.string().min(2).max(80).regex(/^[a-z][a-z0-9-]*$/),
    maxFacts: z.number().int().min(1).max(500),
});
export const timesheetsAssistantContextFactSchema = z.strictObject({
    factType: z.enum(['timesheets.time-entry-summary', 'timesheets.employee-week-summary']),
    value: z.record(z.string().min(1).max(120), z.unknown()),
    sourceRevision: z.string().min(1).max(160),
    observedAt: z.string().datetime({ offset: true }),
    redactedFields: z.array(z.string().min(1).max(512)).max(100),
});
export const timesheetsAssistantContextResultSchema = z.strictObject({
    providerId: z.literal(timesheetsAssistantContextProviderId),
    providerModuleId: z.literal('timesheets'),
    capability: z.literal(timesheetsAssistantContextCapability),
    facts: z.array(timesheetsAssistantContextFactSchema).max(1),
    unavailableReason: z.enum([
        'not-entitled',
        'not-enabled',
        'permission-denied',
        'provider-failed',
    ]).nullable(),
});
//# sourceMappingURL=timesheets-assistant-context.contract.js.map